import * as resorts from '~/config/ids/idsResorts';
import { WINTER } from '~/config/types/typesSeasons';

/**
 *
 */
export const state = () => ({
    isResortHeaderVisible: true,
    isTransitionToLeft: null,
    isPortraitMode: true,
    isInitialSliderAnimationDone: false,
    isOptionsFlyoutOpen: false,
    isOptionsFlyoutEnabled: false,
});

export const mutations = {
    setIsResortHeaderVisible(state, flag) {
        state.isResortHeaderVisible = flag;
    },

    setIsTransitionToLeft(state, flag) {
        state.isTransitionToLeft = flag;
    },

    setIsPortraitMode(state, flag) {
        state.isPortraitMode = flag;
    },

    setIsInitialSliderAnimationDone(state, flag) {
        state.isInitialSliderAnimationDone = flag;
    },

    setIsOptionsFlyoutOpen(state, flag) {
        state.isOptionsFlyoutOpen = flag;

        if (flag) {
            if (this.$gtm) this.$gtm.pushEvent('Click - Filter', 'Filter');
        }
    },

    setIsOptionsFlyoutEnabled(state, flag) {
        state.isOptionsFlyoutEnabled = flag;
    },
};

export const actions = {
    setIsPortraitMode({ commit }) {
        const isPortraitMode = window.innerWidth < window.innerHeight;
        commit('setIsPortraitMode', isPortraitMode);
    },
};

export const getters = {
    showElevationData(state, otherGetters, rootState) {
        return true;
    },

    showSnowData(state, otherGetters, rootState) {
        return rootState.currentSeason === WINTER;
    },

    showWebcamSlider(state, otherGetters, rootState) {
        return !rootState.isNativeApp;
    },

    showLiveDataFlyoutButton(state, otherGetters, rootState) {
        return rootState.currentResortId !== resorts.SUMMER_JR;
    },
};
